import { NgModule } from "@angular/core";
import { MapModule } from "~app/common/components/map/map.module";
import { RaskCommonModule } from "~app/common/rask-common.module";
import { PlaneraModule } from "../planera/planera.module";
import { SharedModule } from "../shared/shared.module";
import { ExternArbetsorderDetailsComponent } from "./extern-arbetsorder/extern-arbetsorder-search/extern-arbetsorder-details/extern-arbetsorder-details.component";
import { ExternArbetsorderDetailsViol2Component } from "./extern-arbetsorder/extern-arbetsorder-search/extern-arbetsorder-details/viol2/extern-arbetsorder-details-viol2.component";
import { ExternArbetsorderDetailsViol3Component } from "./extern-arbetsorder/extern-arbetsorder-search/extern-arbetsorder-details/viol3/extern-arbetsorder-details-viol3.component";
import { ExternArbetsorderSearchPanelComponent } from "./extern-arbetsorder/extern-arbetsorder-search/extern-arbetsorder-search-panel/extern-arbetsorder-search-panel.component";
import { ExternArbetsorderSearchResultComponent } from "./extern-arbetsorder/extern-arbetsorder-search/extern-arbetsorder-search-result/extern-arbetsorder-search-result.component";
import { ExternArbetsorderSearchComponent } from "./extern-arbetsorder/extern-arbetsorder-search/extern-arbetsorder-search.component";
import { ExternArbetsorderService } from "./extern-arbetsorder/services/externArbetsorder.service";

@NgModule({
    imports: [
        RaskCommonModule,
        MapModule,
        PlaneraModule,
        SharedModule,
        ExternArbetsorderSearchComponent,
        ExternArbetsorderSearchResultComponent,
        ExternArbetsorderSearchPanelComponent,
        ExternArbetsorderDetailsComponent,
        ExternArbetsorderDetailsViol2Component,
        ExternArbetsorderDetailsViol3Component
    ],
    providers: [ExternArbetsorderService],
    exports: []
})
export class LeveransModule { }
